import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LOCALSTORAGE } from '../../libs/constants';
import { authenticate } from '../login-api';
import { LoginRequest } from '../models/LoginRequest';

export interface stateTypes {
    isAuthorized: boolean,
    token: string | null,
    userName: string | null,
    userId: number | null
}

const initialState: stateTypes = {
    isAuthorized: false,
    token: null,
    userName: null,
    userId: null
};

export const login = createAsyncThunk('auth/login', async (req: LoginRequest) => {
  const response = (await authenticate(req)).data;
  const data = response;
  return data;
})

const snackbarsSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
      logout(state) {
        localStorage && localStorage.clear();
        return { ...state, isAuthorized: false, token: null }
      },
      setAuth(state) {
        const authToken = localStorage && localStorage.getItem(LOCALSTORAGE.token) !== undefined ? localStorage.getItem(LOCALSTORAGE.token) : null;
        const authName = localStorage && localStorage.getItem(LOCALSTORAGE.usename) !== undefined ? localStorage.getItem(LOCALSTORAGE.usename) : null;
        const authId = localStorage && localStorage.getItem(LOCALSTORAGE.userId) !== undefined ? Number(localStorage.getItem(LOCALSTORAGE.userId)) : null;
        const auth = authToken && authName ? true : false;
        return {...state, token: authToken, isAuthorized: auth, userName: authName, userId: authId}
      }
    },
    extraReducers(builder) {
      builder
      .addCase(login.fulfilled, (state, action) => {
          localStorage && localStorage.setItem(LOCALSTORAGE.token, action.payload.token);
          localStorage && localStorage.setItem(LOCALSTORAGE.usename, action.payload.username);
          localStorage && localStorage.setItem(LOCALSTORAGE.userId, action.payload.userId);
          return{...state, token:  action.payload.token, isAuthorized: true, userName: action.payload.username, userId: action.payload.userId}
      })
    }
});

export const { logout, setAuth } = snackbarsSlice.actions;

export default snackbarsSlice.reducer;